import { supabase } from './supabase';

export async function createNotification(userId, type, title, body, linkView = '', linkParams = {}) {
  if (!userId) return null;
  const { data, error } = await supabase
    .from('notifications')
    .insert({ user_id: userId, type, title, body, link_view: linkView, link_params: linkParams })
    .select()
    .single();
  if (error) console.error('createNotification error:', error);
  return data;
}

export async function getNotifications(userId, limit = 50) {
  const { data, error } = await supabase
    .from('notifications')
    .select('*')
    .eq('user_id', userId)
    .order('created_at', { ascending: false })
    .limit(limit);
  if (error) console.error('getNotifications error:', error);
  return data || [];
}

export async function markNotificationRead(notificationId) {
  const { error } = await supabase
    .from('notifications')
    .update({ is_read: true })
    .eq('id', notificationId);
  if (error) console.error('markNotificationRead error:', error);
  return !error;
}

export async function markAllNotificationsRead(userId) {
  const { error } = await supabase
    .from('notifications')
    .update({ is_read: true })
    .eq('user_id', userId)
    .eq('is_read', false);
  if (error) console.error('markAllNotificationsRead error:', error);
  return !error;
}

export async function generateSessionNotifications(userId, tasks, evidence) {
  const key = `notificationChecked_${userId}`;
  if (sessionStorage.getItem(key)) return;
  sessionStorage.setItem(key, '1');

  const now = new Date();
  const toInsert = [];

  // Overdue tasks (180+ days past due_date)
  tasks.forEach(task => {
    if (task.status === 'done' || !task.due_date) return;
    const days = (now - new Date(task.due_date)) / (1000 * 60 * 60 * 24);
    if (days >= 180) {
      toInsert.push({
        user_id:     userId,
        type:        'overdue_task',
        title:       'Overdue Task',
        body:        `"${task.title}" is ${Math.floor(days)} days overdue.`,
        link_view:   'tasks',
        link_params: { task_id: task.id },
      });
    }
  });

  // Expiring evidence (≤30 days)
  evidence.forEach(ev => {
    if (!ev.expires_at) return;
    const days = Math.floor((new Date(ev.expires_at) - now) / (1000 * 60 * 60 * 24));
    if (days >= 0 && days <= 30) {
      toInsert.push({
        user_id:     userId,
        type:        days <= 7 ? 'evidence_expiring_critical' : 'evidence_expiring',
        title:       days <= 7 ? 'Evidence Expiring Soon' : 'Evidence Expiring in 30 Days',
        body:        `"${ev.title || ev.file_name}" expires in ${days} day${days === 1 ? '' : 's'}.`,
        link_view:   'evidence',
        link_params: { evidence_id: ev.id },
      });
    } else if (days < 0) {
      toInsert.push({
        user_id:     userId,
        type:        'evidence_expired',
        title:       'Evidence Expired',
        body:        `"${ev.title || ev.file_name}" has expired and needs renewal.`,
        link_view:   'evidence',
        link_params: { evidence_id: ev.id },
      });
    }
  });

  if (toInsert.length === 0) return;

  // De-duplicate: only insert if no matching unread notification created in last 24 hours
  const { data: existing } = await supabase
    .from('notifications')
    .select('body')
    .eq('user_id', userId)
    .eq('is_read', false)
    .gte('created_at', new Date(now - 24 * 60 * 60 * 1000).toISOString());

  const existingBodies = new Set((existing || []).map(n => n.body));
  const newItems = toInsert.filter(n => !existingBodies.has(n.body));
  if (newItems.length === 0) return;

  const { error } = await supabase.from('notifications').insert(newItems);
  if (error) console.error('generateSessionNotifications error:', error);
}
